var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCircleArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 18,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 19,
  height: 18,
  fill: "#F2F0F0",
  rx: 9
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#999090",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m7.5 12.815 4-4-4-4"
})));
export default SvgCircleArrowRight;